import { useState } from 'react';
import I18n from '../../../config/i18n';
import GoogleTagManagerNg from '../../../features/tracking/GoogleTagManagerNg';
import {
  CPLStartAvailabilityFormEvent,
  CPLSubmitAvailabilityFormEvent,
} from '../../../features/tracking/types';
import AvailabilityForm, { AvailabilityFormProps } from './AvailabilityForm';

import './AvailabilityRequest.css';

export default function AvailabilityRequest({
  accommodationId,
  minDate,
}: Pick<AvailabilityFormProps, 'accommodationId' | 'minDate'>): JSX.Element {
  const [submitted, setSumitted] = useState(false);
  const [open, setOpen] = useState(false);

  function handleSuccess(): void {
    const trackingEvent: CPLSubmitAvailabilityFormEvent = {
      event: 'cpl_submit_availability_form',
      parameters: {
        accommodation_id: accommodationId,
      },
    };
    GoogleTagManagerNg.trackEvent(trackingEvent);
    setSumitted(true);
  }

  function handleFail(): void {
    // TODO => CPT-1732
    window.alert(I18n.t('inquiry_form.fail_notification')); // eslint-disable-line no-alert
  }

  function handleAvailabilityButtonClick(): void {
    const trackingEvent: CPLStartAvailabilityFormEvent = {
      event: 'cpl_start_availability_form',
      parameters: {
        accommodation_id: accommodationId,
      },
    };
    GoogleTagManagerNg.trackEvent(trackingEvent);
    setOpen(!open);
  }

  if (submitted) {
    return (
      <div className="availability-request-success">
        <h3 className="availability-request-headline">{I18n.t('inquiry_form.thank_you_1')}</h3>
        <p>{I18n.t('inquiry_form.thank_you_2')}</p>
      </div>
    );
  }

  if (open) {
    return (
      <AvailabilityForm
        onSuccess={(): void => handleSuccess()}
        onFail={(): void => handleFail()}
        accommodationId={accommodationId}
        minDate={minDate}
      />
    );
  }

  return (
    <button
      className="availability-request-button"
      onClick={handleAvailabilityButtonClick}
      type="button"
    >
      {I18n.t('activerecord.attributes.inquiry_form.inquiry')}
    </button>
  );
}
